import type { ScenarioRouteAccess } from './Scenario/config';
import type { RouteAccessProps } from 'types';

// Keep the current site when possible, then try other sites on the same platform.
export function findAccessibleSite(
  access: ScenarioRouteAccess,
  accessProps: RouteAccessProps,
  platforms: General.PlatformUpperCase[],
  regions: Partial<Record<General.PlatformUpperCase, General.UpperCaseRegion[]>>,
  currentPlatform?: General.PlatformUpperCase,
  currentRegion?: General.UpperCaseRegion,
) {
  const candidates = [
    ...platforms.filter((platform) => platform === currentPlatform),
    ...platforms.filter((platform) => platform !== currentPlatform),
  ];

  for (const platform of candidates) {
    const availableRegions = regions[platform] || [];
    const candidates = [
      ...availableRegions.filter((region) => region === currentRegion),
      ...availableRegions.filter((region) => region !== currentRegion),
    ];
    for (const region of candidates) {
      if (access({ ...accessProps, platform, region })) {
        return { platform, region };
      }
    }
  }
}
